import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/404.webp'


const _withScopeId = n => (_pushScopeId("data-v-015ba512"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "not-found__wrapper" }
const _hoisted_2 = { class: "not-found" }
const _hoisted_3 = { class: "not-found__content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.t("notFound.title")), 1),
        _hoisted_4
      ])
    ])
  ]))
}